'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var edit = function edit() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isEditing = _ref.isEditing;
  var onActivate = _ref.onActivate;
  var onValue = _ref.onValue;
  var _ref$getEditedValue = _ref.getEditedValue;
  var getEditedValue = _ref$getEditedValue === undefined ? function (v) {
    return v;
  } : _ref$getEditedValue;
  var _ref$editingProps = _ref.editingProps;
  var editingProps = _ref$editingProps === undefined ? {} : _ref$editingProps;
  var _ref$activateEvent = _ref.activateEvent;
  var activateEvent = _ref$activateEvent === undefined ? 'onClick' : _ref$activateEvent;

  if (!isEditing) {
    throw new Error('edit - Missing isEditing!');
  }
  if (!onActivate) {
    throw new Error('edit - Missing onActivate!');
  }
  if (!onValue) {
    throw new Error('edit - Missing onValue!');
  }

  var defaultValueComponent = function defaultValueComponent(value, extraParameters, props) {
    return props;
  };

  return function (editorComponent) {
    var valueComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultValueComponent;

    if (!editorComponent) {
      throw new Error('edit - Missing editor!');
    }

    return function (value, extraParameters) {
      var _extends2;

      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return isEditing(extraParameters) ? {
        children: _react2.default.createElement(editorComponent, _extends({}, props, (_extends2 = {
          extraParameters: extraParameters
        }, _defineProperty(_extends2, editingProps.value || 'value', getEditedValue(value)), _defineProperty(_extends2, editingProps.onValue || 'onValue', function (v) {
          return onValue(_extends({ value: v }, extraParameters));
        }), _extends2)))
      } : _extends({}, valueComponent(value, extraParameters, props), _defineProperty({}, activateEvent, function (event) {
        return onActivate(_extends({ event: event }, extraParameters));
      }));
    };
  };
};

exports.default = edit;


//////////////////
// WEBPACK FOOTER
// ./~/react-edit/dist/edit.js
// module id = 1266
// module chunks = 0